/* eslint-disable react/prop-types */
import React from 'react';
import { Col, Divider, Empty, Form, Select } from 'antd';

function RequiredDocumentsSettings({ fieldsPermissions, documentTypeOptions }) {
  const hasDocumentsPermissions =
    fieldsPermissions?.RequiredDocumentsCT.access !== 0 ||
    fieldsPermissions?.RequiredDocumentsInstructor.access !== 0 ||
    fieldsPermissions?.RequiredDocumentsDriver.access !== 0 ||
    fieldsPermissions?.RequiredDocumentsTransport.access !== 0 ||
    fieldsPermissions?.RequiredDocumentsVehicle.access !== 0;

  if (!hasDocumentsPermissions)
    return (
      <div style={{ height: 100, width: '100%' }}>
        <Empty description="Nenhuma configuração de documentos obrigatórios disponível" />
      </div>
    );

  return (
    <>
      <Col span={24}>
        <Divider className="configuration-divider" orientation="left">
          Documentos Obrigatórios
        </Divider>
      </Col>

      {fieldsPermissions?.RequiredDocumentsCT.access !== 0 && (
        <Col span={6}>
          <Form.Item
            label="Centro de Treinamento"
            name="requiredDocumentsCT"
            rules={[
              {
                required: fieldsPermissions?.RequiredDocumentsCT.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Select
              mode="multiple"
              allowClear
              placeholder="Selecione"
              optionFilterProp="label"
              showSearch
              options={documentTypeOptions}
              dropdownStyle={{ borderRadius: 16 }}
              maxTagCount="responsive"
              disabled={fieldsPermissions?.RequiredDocumentsCT.access !== 2}
            />
          </Form.Item>
        </Col>
      )}

      {fieldsPermissions?.RequiredDocumentsInstructor.access !== 0 && (
        <Col span={6}>
          <Form.Item
            label="Instrutor"
            name="requiredDocumentsInstructor"
            rules={[
              {
                required: fieldsPermissions?.RequiredDocumentsInstructor.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Select
              mode="multiple"
              allowClear
              placeholder="Selecione"
              optionFilterProp="label"
              showSearch
              options={documentTypeOptions}
              dropdownStyle={{ borderRadius: 16 }}
              maxTagCount="responsive"
              disabled={fieldsPermissions?.RequiredDocumentsInstructor.access !== 2}
            />
          </Form.Item>
        </Col>
      )}

      {fieldsPermissions?.RequiredDocumentsDriver.access !== 0 && (
        <Col span={6}>
          <Form.Item
            label="Motorista"
            name="requiredDocumentsDriver"
            rules={[
              {
                required: fieldsPermissions?.RequiredDocumentsDriver.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Select
              mode="multiple"
              allowClear
              placeholder="Selecione"
              optionFilterProp="label"
              showSearch
              options={documentTypeOptions}
              dropdownStyle={{ borderRadius: 16 }}
              maxTagCount="responsive"
              disabled={fieldsPermissions?.RequiredDocumentsDriver.access !== 2}
            />
          </Form.Item>
        </Col>
      )}

      {fieldsPermissions?.RequiredDocumentsTransport.access !== 0 && (
        <Col span={6}>
          <Form.Item
            label="Transporte"
            name="requiredDocumentsTransport"
            rules={[
              {
                required: fieldsPermissions?.RequiredDocumentsTransport.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Select
              mode="multiple"
              allowClear
              placeholder="Selecione"
              optionFilterProp="label"
              showSearch
              options={documentTypeOptions}
              dropdownStyle={{ borderRadius: 16 }}
              maxTagCount="responsive"
              disabled={fieldsPermissions?.RequiredDocumentsTransport.access !== 2}
            />
          </Form.Item>
        </Col>
      )}

      {fieldsPermissions?.RequiredDocumentsVehicle.access !== 0 && (
        <Col span={6}>
          <Form.Item
            label="Veículo"
            name="requiredDocumentsVehicle"
            rules={[
              {
                required: fieldsPermissions?.RequiredDocumentsVehicle.isRequired,
                message: 'Campo obrigatório!',
              },
            ]}
          >
            <Select
              mode="multiple"
              allowClear
              placeholder="Selecione"
              optionFilterProp="label"
              showSearch
              options={documentTypeOptions}
              dropdownStyle={{ borderRadius: 16 }}
              maxTagCount="responsive"
              disabled={fieldsPermissions?.RequiredDocumentsVehicle.access !== 2}
            />
          </Form.Item>
        </Col>
      )}
    </>
  );
}

export default RequiredDocumentsSettings;
